import useShopifyFetcher from '../shopify'

export type SwitchPanelResponse = {
  access_token: string
  refresh_token: string
}

function useSwitchPanel(): [
  (panelId: number) => Promise<void>,
  {
    data: SwitchPanelResponse | null
    isLoading: boolean
    isError: boolean
    isSuccess: boolean
    isFinished: boolean
  },
] {
  const [baseFetcher, meta] = useShopifyFetcher()

  const switchPanel = async (panelId: number) => {
    return await baseFetcher(
      `${import.meta.env.VITE_APP_URL}/shopify/panels/${panelId}/switch`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      },
    )
  }

  return [
    switchPanel,
    {
      data: meta.data,
      isLoading: meta.isLoading,
      isError: meta.isError,
      isSuccess: meta.isSuccess,
      isFinished: meta.isFinished,
    },
  ]
}

export default useSwitchPanel
